import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/App/actions';
import { Spinner } from 'components/Loading';
import ImportantTodoList from './ImportantTodos';
import Notification from '../Notification';

import './style.scss';

const MyFocus = ({
  notifications,
  markAllReads,
  markRead,
  dismiss,
  widget = false,
}) => {
  const dispatch = useDispatch();
  const unreadNotifications = notifications.filter(notification => !notification.isRead);
  const tasksInfo = useSelector(state => state.global.tasksInfo);
  const { assignedTasks, loginTasks, weddings, leads } = tasksInfo || {};
  const isLoading = !assignedTasks || !loginTasks || !weddings || !leads;
  const { getFocusTasks, getGeneralTasks, getProjectTasks, getLeadTasks } = bindActionCreators(actions, dispatch);

  useEffect(() => {
    if (!assignedTasks) getFocusTasks();
  }, [assignedTasks]);

  useEffect(() => {
    if(!loginTasks) getGeneralTasks();
  }, [loginTasks]);

  useEffect(() => {
    if(!weddings) getProjectTasks();
  }, [weddings]);

  useEffect(() => {
    if(!leads) getLeadTasks();
  }, [leads]);

  return (
    <div className="notification-center__tab notification-center__tab--my-focus">
      { !widget && (
        <div className="my-focus__to-dos">
          {assignedTasks && <ImportantTodoList tasks={assignedTasks} />}
          {isLoading && (
            <Spinner
              height={10}
              width={3}
              margin={0}
            />
          )}
        </div>
      )}
      <div className="my-focus__notifications notification-menu-focus">
        {!widget && !!unreadNotifications.length && (
          <div className="my-focus__notification-header">
            <h2 className="my-focus__heading">
              Unread Notifications
            </h2>
            <button
              className="button--unstyled gold"
              onClick={markAllReads}
            >
              Mark All Read
            </button>
          </div>
        )}
        {unreadNotifications.map((item) => {
          const { id } = item;
          return (
            <Notification
              key={id}
              notification={item}
              myFocus
              markRead={markRead}
              dismiss={dismiss}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MyFocus;
